import React from 'react';
import { Link } from 'react-router-dom';
import { images } from '../../data/images';
import { livingCraftFacts } from '../../data/navigation';
export function LivingCraft() {
  return <section className="bg-majorelle text-white" data-id="element-318" data-mp="3fa9v544tte39">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 py-16 lg:grid-cols-2 lg:gap-20 lg:px-8 lg:py-24" data-id="element-319" data-mp="3fbkxr0mjcfss">
        <img src={images.livingCraft} alt="Handen beschilderen een keramisch bord met een blauw-wit patroon in een pottenbakkerij in Safi" className="aspect-[4/3] w-full rounded-2xl object-cover" data-id="element-320" data-mp="3kb7dbgpu684r" />
        <div data-id="element-321" data-mp="2401l6al6j0d">
          <h2 className="text-3xl font-semibold leading-tight tracking-tight sm:text-4xl" data-id="element-322" data-mp="22giz91gjvvf">Handgemaakt door Marokkaanse ambachtslieden</h2>
          <p className="mt-4 max-w-lg text-[17px] leading-relaxed text-white/80" data-id="element-323" data-mp="70i0vqn5dp5b">
            Elk stuk is uniek. Kleine verschillen in kleur en vorm zijn geen fout — ze zijn het bewijs van echt handwerk.
          </p>
          <dl className="mt-8 border-t border-white/20" data-id="element-324" data-mp="zkovmdtaogz7">
            {livingCraftFacts.map(f => <div key={f.title} className="grid grid-cols-[7rem_1fr] gap-4 border-b border-white/20 py-4" data-id="element-325" data-mp="2f1g3u1koobap">
                <dt className="font-semibold" data-id="element-326" data-mp="2ssm9kfek3561">{f.title}</dt>
                <dd className="text-white/80" data-id="element-327" data-mp="2su5r09by7m9e">{f.text}</dd>
              </div>)}
          </dl>
          <Link to="/living/collectie/alles" className="mt-8 inline-flex h-12 items-center whitespace-nowrap rounded-lg bg-terracotta px-6 text-[15px] font-semibold text-white transition-colors duration-150 hover:bg-terracotta-dark" data-id="element-328" data-mp="2o01hpjf7n255">
            Bekijk alle producten
          </Link>
        </div>
      </div>
    </section>;
}